import React, { Component } from 'react'
import front_back from '../static/images/front_back.png'
import Card from 'react-bootstrap/Card'
export default class About extends Component {
    render() {
        return (

            <div className='col-xl-4 col-xs-4 col-sm-4 col-md-4'>
                <Card className='card text-white bg-info mb-3' style={{ display: 'flex', justifyContent: 'center' }}>

                    <Card.Body>
                        <Card.Title>Buna Ale,</Card.Title>
                        <Card.Text> Am in gand acest proiect de cand mi-ai trimis emailul.
                            <br />L-am mentionat in momentul cand am gasit o cale sa il pot realiza
                            <br />La un moment dat, in timpul unei intalniri, m-ai intrebat care este proiectul meu de suflet.
                            Tin minte ca am spus proiectul din Norvegia(🐟) dar prin felul in care vorbeam reiesea FedEx.
                            <br />Acum pot sa iti spun cu toata increderea ca acesta a devenit proiectul meu de suflet de la primul email
                            <br />Tot ce am facut pana acum a fost cu mult drag si m-am bucurat de fiecare moment
                            <br />Imi doresc sa il dezvolt in continuare, sa devina ceva ce iti poate fi de ajutor
                           </Card.Text>
                           <Card.Subtitle>Scroll pana jos</Card.Subtitle>
                           <Card.Text><br/></Card.Text>
                        <Card.Img variant="bottom" src={front_back} />
                        <Card.Footer >Nu puteam sa nu includ si prima gluma IT pe care ti-am trimis-o, a si rezonat cu tine ' "interfata cu utilizatorul" ...plina de zambete si pasnica in esenta..'
                            <br/>Te Iubesc! Esti cea mai tare!</Card.Footer>
                            <Card.Link href="/Chart">Graficele</Card.Link>
                        
                    </Card.Body>
                </Card>
            </div>
        )
    }
}
